export default __webpack_public_path__ + "static/media/blog_disp.36283fa1.png";